module.exports = __webpack_public_path__ + "media/images/gallery/aurorae/2001-11-05/10-769bee8ed59a4e139d37abc6f2654866.jpg";